import { createRoot } from "react-dom/client"
import { Provider } from "react-redux"
import { ConnectedRouter } from "connected-react-router"
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns"
import { LocalizationProvider } from "@mui/x-date-pickers"

import {
    ApolloClient,
    InMemoryCache,
    ApolloProvider,
    createHttpLink,
} from "@apollo/client"
import { setContext } from "@apollo/client/link/context"

import "@fontsource/roboto"
import makeStore, { history } from "./redux/store"

import enLocale from "date-fns/locale/en-US"
import esLocale from "date-fns/locale/es"

import "./index.css"
import App from "./App"
import * as serviceWorker from "./serviceWorker"
const { VITE_APP_GRAPHQL } = import.meta.env

const httpLink = createHttpLink({
    uri: VITE_APP_GRAPHQL, // should fetch from env
})

const authLink = setContext((_, { headers }) => {
    return {
        headers: {
            ...headers,
            "x-api-token":
                "Bearer " +
                JSON.parse(localStorage.getItem("okta-token-storage"))
                    .accessToken.accessToken,
        },
    }
})

const client = new ApolloClient({
    link: authLink.concat(httpLink),
    cache: new InMemoryCache(),
})
const userLanguage = navigator.language || navigator.userLanguage

const container = document.getElementById("root")
const root = createRoot(container)
const store = makeStore()

root.render(
    <ApolloProvider client={client}>
        <Provider store={store}>
            <ConnectedRouter history={history} noInitialPop>
                <LocalizationProvider
                    dateAdapter={AdapterDateFns}
                    adapterLocale={
                        userLanguage.startsWith("es") ? esLocale : enLocale
                    }
                >
                    <App />
                </LocalizationProvider>
            </ConnectedRouter>
        </Provider>
    </ApolloProvider>
)

if (window.Cypress) {
    window.redux_store = store
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
